/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const MultiValueRemove = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.MultiValueRemove;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

MultiValueRemove.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      MultiValueRemove: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

MultiValueRemove.defaultProps = {
  selectProps: {
    custom: {
      MultiValueRemove: null,
    },
  },
  children: null,
};

export default MultiValueRemove;
